import { createSlice } from '@reduxjs/toolkit';

import { getAllState, getAllDistrict } from '../api/location';

export const locationSlice = createSlice({
  name: 'location',
  initialState: {
    loading: false,
    error: {},
    states: {},

    districts: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    // get all districts
    [getAllDistrict.pending]: (state) => {
      state.loading = true;
    },
    [getAllDistrict.fulfilled]: (state, action) => {
      state.loading = false;
      state.districts = action.payload;
      state.error = {};
    },
    [getAllDistrict.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // get all state
    [getAllState.pending]: (state) => {
      state.loading = true;
    },
    [getAllState.fulfilled]: (state, action) => {
      state.loading = false;
      state.states = action.payload;
      state.error = {};
    },
    [getAllState.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = locationSlice.actions;

export default locationSlice.reducer;
